import React from 'react';
import { getProjectStatus, projectStatuses } from '../config/projectStatuses';
import { lifecycleExplanations } from '../config/lifecycleExplanations';
import './ProjectStatusChevron.css';

function ProjectStatusChevron({ status }) {
  const currentStatus = getProjectStatus(status);
  const explanation = Object.entries(lifecycleExplanations)
    .find(([label]) => label.toLowerCase() === currentStatus.toLowerCase())?.[1];

  return (
    <div className="project-status-chevron">
      <div
        role="region"
        aria-label={`Project status chevrons: ${currentStatus}`}
      >
        <ol className="project-status-chevron-list" aria-label="Project statuses">
          {projectStatuses.map(label => {
            const isCurrent = label === currentStatus;
            return (
              <li
                key={label}
                className={`project-status-chevron-step${isCurrent ? ' is-current' : ''}`}
                aria-current={isCurrent ? 'step' : undefined}
                title={isCurrent ? explanation || label : label}
              >
                <svg viewBox="0 0 180 100" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                  <polygon points="3,2 160,2 177,50 160,98 3,98 20,50" />
                </svg>
                <span>{label}</span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}

export default ProjectStatusChevron;
